import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import itLocale from "date-fns/locale/it";
import moment from "moment/moment";

export class LocalizedUtils extends DateFnsUtils {
    getDatePickerHeaderText(date) {
        return format(date, "EE, d MMMM", { locale: itLocale });
    }
}

export const dateConvertedItalian = (date) => {
    return moment(date).format("DD MMM YYYY").toUpperCase();
}

export const dateConvertedItalianWithFirstCapitalMonth = (date) => {
    if (!date){
        return "";
    }
    let newDate = moment(date).format("DD MMM YYYY");
    newDate = newDate.substr(0, 3) + newDate.charAt(3).toUpperCase() + newDate.substr(4, newDate.length);
    return newDate;
}

export const dateConveretedItalianFullMonthName = (date) => {
    if (!date){
        return "";
    } else if (date === '-') {
        return date;
    }
    let newDate = moment(date).format("DD MMMM YYYY");
    newDate = newDate.substr(0, 3) + newDate.charAt(3).toUpperCase() + newDate.substr(4, newDate.length);
    return newDate;
}

export const formatDateWithTime = (date) => {
    if (!date) {
        return "";
    }
    return moment(date).format("DD/MM/YY HH:mm");
}
